/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { BsFilter } from 'react-icons/bs';
import { MdAssignmentInd, MdPersonPin, MdRemoveRedEye } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import { CircularProgress, Radio } from '@material-ui/core';
import { Form, FormikProvider, useFormik } from 'formik';
import moment from 'moment';

import AtribuirUser from '~/assets/AtribuirUser.svg';
import ActionModal from '~/components/ActionModal';
import Button from '~/components/Button';
import ConfirmationModal from '~/components/ConfirmationModal';
import DataListSync from '~/components/DataListSync';
import FilterChips from '~/components/FilterChips';
import InputSearchDebounce, {
  SearchInputImperativeProps,
} from '~/components/InputSearchDebounce';
import Modal from '~/components/Modal';
import SelectWithAvatar from '~/components/SelectWithAvatar';
import Sidesheet from '~/components/Sidesheet';
import PaginatedTable from '~/components/Table/PaginatedTable';
import { PaginatedTableProps } from '~/components/Table/PaginatedTable/interface';
import { useAuth } from '~/hooks/auth';
import { useNavigation } from '~/hooks/Navigation';
import { useSubmitModal } from '~/hooks/SubmitModal';
import { IState } from '~/store';
import { getProcessesRequest } from '~/store/modules/processes/actions';
import {
  getTaskRequest,
  claimTaskRequest,
  getTasksRequest,
} from '~/store/modules/tasks/actions';
import {
  DueDate,
  IFilterTaskParams,
  IGetTasksParams,
  ITask,
} from '~/store/modules/tasks/types';
import { getUsersByGroupsRequest } from '~/store/modules/users/actions';
import { ICamundaUser } from '~/store/modules/users/types';
import colors from '~/styles/colors';
import { permissions } from '~/types/constants';

import TaskDetails from '../TaskDetails';
import FilterTasksForm from './FilterTasksForm';
import {
  Container,
  FilterButton,
  Wrapper,
  FilterWrapper,
  SidesheetCustomStyle,
  FormControlLabel,
  RadioGroup,
  FormControl,
  AssingTaskModalContainer,
  ButtonsContainer,
  SelectInputContainer,
  ModalContainer,
  HeaderContainer,
} from './styles';

interface FormTableData {
  processDefinitionNames?: string[];
}

moment.locale('pt-br');

const AvailableTasks: React.FC = () => {
  const [resetPage, setResetPage] = useState<boolean>(false);
  const [customLimit, setCustomLimit] = useState<number>(15);
  const [modalAssigneeTask, setModalAssigneeTask] = useState<boolean>(false);
  const [searchAvailable, setSearchAvailable] = useState<string>('');
  const [modalTaskFilter, setModalTaskFilter] = useState<boolean>(false);
  const [modalTaskDetail, setModalTaskDetail] = useState<boolean>(false);
  const [filterParams, setFilterParams] = useState<IFilterTaskParams>({});
  const [selectedTasks, setSelectTasks] = useState<Array<ITask>>([]);
  const [assignableTasks, setAssignableTasks] = useState<ITask>();
  const [dataListModal, setDataListModal] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<ICamundaUser>();
  const [
    selectedUserCandidateGroups,
    setSelectedUserCandidateGroups,
  ] = useState<Array<string>>([]);
  const [disableButton, setDisableButton] = useState<boolean>(false);

  const [showCheckBox, setShowCheckBox] = useState<boolean>(false);

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const [taskFailures, setTaskFailures] = useState<Array<ITask>>([]);

  const loading = useSelector((state: IState) => state.tasks.loading);
  const loadingTask = useSelector((state: IState) => state.tasks.loadingTask);
  const loadingAssignee = useSelector(
    (state: IState) => state.tasks.loadingAssignee,
  );
  const sortOrder = useSelector((state: IState) => state.tasks.sortOrder);
  const task = useSelector((state: IState) => state.tasks.task);
  const taskAssigned = useSelector((state: IState) => state.tasks.taskAssigned);
  const taskAssignedError = useSelector(
    (state: IState) => state.tasks.taskAssignedError,
  );

  const taskAssignedFailures = useSelector(
    (state: IState) => state.tasks.taskAssignedFailures,
  );

  const availableTasks = useSelector(
    (state: IState) => state.tasks.taskInstances,
  );
  const count = useSelector((state: IState) => state.tasks.countTasks);
  const processDefinitions = useSelector(
    (state: IState) => state.processes.processes,
  );
  const usersByGroups = useSelector(
    (state: IState) => state.users.usersByGroups,
  );

  const camundaUsers = useSelector((state: IState) => state.users.camundaUsers);

  const loadingUsersByGroups = useSelector(
    (state: IState) => state.users.loadingUsersByGroups,
  );

  const formRef = useRef(null);
  const searchInputRef = useRef<SearchInputImperativeProps>(null);

  const dispatch = useDispatch();
  const { user } = useAuth();
  const { setCanNavigate } = useNavigation();
  const managerId = Number(user.personId);

  const { handler } = useSubmitModal({ disableError: true });

  const buildGetTasksParamsObject = useCallback(
    (overrideParams?: Partial<IGetTasksParams>): IGetTasksParams => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { assigneeIn, ...remainingFilterParams } = { ...filterParams };

      const taskParams: IGetTasksParams = {
        unassigned: true,
        page: 1,
        limit: customLimit,
        sortBy: 'dueDate',
        sortOrder: 'asc',
        taskSearch: searchAvailable,
        ...remainingFilterParams,
        ...overrideParams,
      };

      return taskParams;
    },
    [customLimit, filterParams, searchAvailable],
  );

  const loadTasks = useCallback(
    (overrides?: Partial<IGetTasksParams>) => {
      const taskParams = buildGetTasksParamsObject(overrides);
      dispatch(getTasksRequest(taskParams, user));
    },
    [buildGetTasksParamsObject, dispatch, user],
  );

  const handleChangeRadio = (newDueDate: DueDate | null) => {
    const newFilterParams = { ...filterParams };
    switch (newDueDate) {
      case DueDate.ON_TIME:
        newFilterParams.dueDate = DueDate.ON_TIME;
        break;
      case DueDate.OVERDUE:
        newFilterParams.dueDate = DueDate.OVERDUE;
        break;
      default:
        delete newFilterParams.dueDate;
    }

    setFilterParams(newFilterParams);
    setResetPage(true);
    setCustomLimit(15);
  };

  const handleFilterParams = (data: FormTableData) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { processDefinitionNames, ...rest } = { ...filterParams };
    const newFilterParams: IFilterTaskParams = rest;

    if (
      data?.processDefinitionNames &&
      data.processDefinitionNames?.length > 0
    ) {
      newFilterParams.processDefinitionNames = data.processDefinitionNames;
    }

    setFilterParams(newFilterParams);
  };

  const handleDeleteProcessDefinitionNamesChip = (name: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { processDefinitionNames, ...rest } = { ...filterParams };
    const newFilterParams: IFilterTaskParams = rest;

    const filteredProcessDefinitionNames = filterParams.processDefinitionNames?.filter(
      (selected) => selected !== name,
    );

    if (
      filteredProcessDefinitionNames &&
      filteredProcessDefinitionNames.length > 0
    ) {
      newFilterParams.processDefinitionNames = filteredProcessDefinitionNames;
    }

    setResetPage(true);
    setFilterParams(newFilterParams);
  };

  const handleChangeOrder = () => {
    setResetPage(true);
    setCustomLimit(15);
    if (selectedUser) {
      loadTasks({
        sortOrder: sortOrder === 'asc' ? 'desc' : 'asc',
        limit: 15,
        candidateGroups: selectedUserCandidateGroups,
      });
    } else {
      loadTasks({ sortOrder: sortOrder === 'asc' ? 'desc' : 'asc', limit: 15 });
    }
  };

  const handleSelfAssigeeTask = (tasks: ITask[]) => {
    const taskParams = buildGetTasksParamsObject();

    const taskIds = tasks.map((task) => task.id);

    const confirmOptions = {
      onOk: () =>
        handler(() => {
          dispatch(
            claimTaskRequest(taskIds, user.personId, managerId, {
              params: taskParams,
              user,
            }),
          );
          setDisableButton(false);
        }),

      onCancel: () => {},
    };

    toastr.confirm('Tem certeza que deseja assumir a tarefa?', confirmOptions);
  };

  const handleOpenModalAssigneeTask = (task: ITask) => {
    dispatch(getUsersByGroupsRequest(task.candidateGroups));

    setModalAssigneeTask(!modalAssigneeTask);

    setAssignableTasks(task);
  };

  const handleAssigneeManyTasks = (tasks: ITask[]) => {
    const taskParams = buildGetTasksParamsObject();

    const taskIds = tasks.map((task) => task.id);

    handler(() => {
      dispatch(
        claimTaskRequest(taskIds, Number(selectedUser?.id), managerId, {
          params: taskParams,
          user,
        }),
      );
    });
    setDisableButton(false);
  };

  const handleModalTaskDetail = (task: ITask | null) => {
    if (task) dispatch(getTaskRequest(task.id));

    setModalTaskDetail(!modalTaskDetail);
  };

  const handleChangePage = (page: number, limit: number) => {
    setCustomLimit(limit);
    loadTasks({ page, limit, sortOrder });
  };

  const handleGetTotalCount = (): number => {
    switch (filterParams.dueDate) {
      case DueDate.ON_TIME:
        return count.onTime;
      case DueDate.OVERDUE:
        return count.overdue;
      default:
        return count.total;
    }
  };

  const handleGetStatusColor = (status: string) => {
    switch (status) {
      case 'Atrasada':
        return '#c11e1e';
      case 'Próximo a vencer':
        return '#ff8000';
      case 'No prazo':
        return '#808080';
      default:
        return undefined;
    }
  };

  const handleFilterUserOptions = (search: string) => {
    const filteredUsers = camundaUsers.filter(
      (camundaUser) =>
        camundaUser.firstName.toLowerCase().indexOf(search.toLowerCase()) ===
          0 ||
        camundaUser.lastName.toLowerCase().indexOf(search.toLowerCase()) === 0,
    );

    return filteredUsers?.map((filteredUser) => ({
      id: filteredUser.id,
      label: `${filteredUser.firstName} ${filteredUser.lastName}`,
    }));
  };

  const tableProps: PaginatedTableProps<ITask> = {
    entities: availableTasks,
    selectedEntities: showCheckBox
      ? [selectedTasks, setSelectTasks]
      : undefined,

    loading,
    columns: [
      {
        header: 'Processo',
        value: (task) => task.processDefinitionName,
      },
      {
        id: 'due',
        header: 'Prazo',
        value: (task) => (
          <>
            {moment(new Date(task.due)).format('DD/MM/YYYY')}
            <br />
            <span style={{ width: '95px' }}>{task.status}</span>
          </>
        ),
      },
      {
        header: 'Solicitação',
        value: (task) => task.nomeSolicitacao,
      },
      {
        header: 'Execução',
        value: (task) => task.nomeExecucao,
      },
      {
        header: 'Tarefa',
        value: (task) => task.name,
      },
    ],
    sorting: {
      sortBy: 'due',
      sortOrder,
      onChange: () => handleChangeOrder(),
    },
    emptyTable: {
      title: 'Nenhuma tarefa disponível',
      description:
        'O sistema ainda não possui nenhuma tarefa disponível.\nContate o administrador.',
    },
    menu: [
      {
        label: 'Visualizar detalhes',
        Icon: MdRemoveRedEye,
        action: (task) => handleModalTaskDetail(task),
        permissions: [permissions.VIEW_DETAILS_TASK],
      },
      {
        label: 'Assumir tarefa',
        Icon: MdAssignmentInd,
        action: (task) => handleSelfAssigeeTask([task]),
        permissions: [permissions.ASSIGN_TASK],
      },
      {
        label: !loadingTask ? 'Atribuir tarefa' : 'Atribuindo...',
        Icon: MdPersonPin,
        action: (task) => handleOpenModalAssigneeTask(task),
        permissions: [permissions.ASSIGN_TASK_TO_OTHER],
        disabled: loadingUsersByGroups,
      },
    ],
    borderColor: (task) => handleGetStatusColor(task.status),
    paginationProps: {
      total: handleGetTotalCount(),
      onChange: (page: number, limit: number) => handleChangePage(page, limit),
      resetPage,
      onReset: (reseted) => setResetPage(reseted),
    },
    multipleActionOption: [
      {
        label: 'Assumir Tarefas',
        icon: <MdAssignmentInd size={20} color={colors.primary} />,
        action: () => {
          setShowCheckBox(true);
          setDisableButton(true);
        },
      },
      {
        label: 'Atribuir Tarefas',
        icon: <MdAssignmentInd size={20} color={colors.primary} />,
        action: () => {
          setDataListModal(true);
        },
      },
    ],
    disableMultSelectButton: disableButton,
    loadingMultSelectButton: loading,
  };

  useEffect(() => {
    if (taskAssignedError) {
      setModalAssigneeTask(false);
      setShowCheckBox(false);
      setActionModal(false);
      loadTasks();
    }
  }, [dispatch, loadTasks, taskAssignedError]);

  useEffect(() => {
    if (taskAssigned) {
      setModalAssigneeTask(false);
      setShowCheckBox(false);
      setSelectTasks([]);
      setSelectedUserCandidateGroups([]);
    }
  }, [taskAssigned]);

  useEffect(() => {
    dispatch(getProcessesRequest());
  }, [dispatch]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { dueDate, ...evaluatedFilterParams } = filterParams;

    const canNavigate =
      !searchAvailable &&
      (!evaluatedFilterParams ||
        Object.entries(evaluatedFilterParams).length < 1);

    setCanNavigate(canNavigate);
    loadTasks({ page: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchAvailable, filterParams]);

  useEffect(() => {
    if (!loadingAssignee && taskAssignedFailures?.length > 0) {
      const taskFailures = selectedTasks.filter((selectedTask) =>
        taskAssignedFailures.some(
          (taskAssignedFailure) => taskAssignedFailure.id === selectedTask.id,
        ),
      );

      setTaskFailures(taskFailures);
      setConfirmationModal(true);
      setActionModal(false);
    }
  }, [loadingAssignee, selectedTasks, taskAssignedFailures]);

  useEffect(() => {
    const userSelected = camundaUsers.filter(
      (activeUser) => activeUser?.id === selectedUser?.id,
    );

    const filteredGroups = user.groups.filter((userGroup) =>
      userSelected[0]?.candidateGroups?.some(
        (userSelectedGroup: any) => userGroup.id === userSelectedGroup.id,
      ),
    );

    const groups = filteredGroups.map((filteredGroup) => filteredGroup.id);

    setSelectedUserCandidateGroups(groups);
  }, [camundaUsers, selectedUser, user.groups]);

  useEffect(() => {
    if (selectedUser && selectedUserCandidateGroups?.length > 0) {
      loadTasks({
        candidateGroups: selectedUserCandidateGroups,
      });
      setShowCheckBox(true);
    }
  }, [loadTasks, selectedUser, selectedUserCandidateGroups]);

  useEffect(() => {
    if (selectedTasks.length <= 0) {
      setActionModal(false);
    }
  }, [selectedTasks]);

  useEffect(() => {
    if (showCheckBox === false) {
      setSelectedUser(undefined);
    }
  }, [showCheckBox]);

  const initialValues = {};

  const onSubmit = (data: any) => {
    const { userSelected } = data;

    const taskParams = buildGetTasksParamsObject();

    if (assignableTasks) {
      handler(() => {
        dispatch(
          claimTaskRequest(
            [assignableTasks?.id],
            Number(userSelected[0].value.id),
            managerId,
            {
              params: taskParams,
              user,
            },
          ),
        );
      });
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
  });

  return (
    <Container>
      <Wrapper>
        <FormControl>
          <RadioGroup row>
            <FormControlLabel
              control={<Radio />}
              label={`Todas (${count.total})`}
              checked={!filterParams || !filterParams.dueDate}
              onChange={() => handleChangeRadio(null)}
            />
            <FormControlLabel
              control={<Radio />}
              label={`Atrasadas (${count.overdue})`}
              checked={filterParams && filterParams.dueDate === DueDate.OVERDUE}
              onChange={() => handleChangeRadio(DueDate.OVERDUE)}
            />
            <FormControlLabel
              control={<Radio />}
              label={`No prazo (${count.onTime})`}
              checked={filterParams && filterParams.dueDate === DueDate.ON_TIME}
              onChange={() => handleChangeRadio(DueDate.ON_TIME)}
            />
          </RadioGroup>
        </FormControl>
        <FilterWrapper>
          <InputSearchDebounce
            ref={searchInputRef}
            placeholder="Buscar uma solicitação ou execução"
            getSearch={(search) => setSearchAvailable(search)}
          />
          <FilterButton
            type="button"
            onClick={() => setModalTaskFilter(!modalTaskFilter)}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <>
                <BsFilter size={20} color="white" />
                Filtrar
              </>
            )}
          </FilterButton>
        </FilterWrapper>
      </Wrapper>
      <FilterChips
        filterParams={[
          {
            list: filterParams.processDefinitionNames,
            label: (process) => process,
            onDelete: (process) =>
              handleDeleteProcessDefinitionNamesChip(process),
          },
        ]}
        onClear={() => setFilterParams({})}
      />
      <Sidesheet
        title="Filtro"
        open={modalTaskFilter}
        modalState={() => setModalTaskFilter(false)}
        sidesheetSize="450px"
      >
        <FilterTasksForm
          processDefinitions={processDefinitions}
          filterParams={filterParams}
          onSubmit={(submitValues) => {
            handleFilterParams(submitValues);
            setModalTaskFilter(false);
            setResetPage(true);
          }}
        />
        <SidesheetCustomStyle />
      </Sidesheet>
      <PaginatedTable {...tableProps} />

      <ActionModal
        selectedItemsLength={selectedTasks.length}
        selectedUser={selectedUser}
        selectUserText="Atribuir em massa para:"
        onClear={() => {
          setShowCheckBox(false);
          setDisableButton(false);
          setSelectTasks([]);
          setSelectedUser(undefined);
          loadTasks();
        }}
        buttonOptions={
          selectedUser
            ? [
                {
                  icon: <MdAssignmentInd size={16} />,
                  label: 'Atribuir tarefas',
                  action: () => {
                    handleAssigneeManyTasks(selectedTasks);
                  },
                  permissions: [permissions.ASSIGN_TASK_TO_OTHER],
                },
              ]
            : [
                {
                  icon: <MdAssignmentInd size={16} />,
                  label: 'Assumir tarefas ',
                  action: () => {
                    handleSelfAssigeeTask(selectedTasks);
                  },
                  permissions: [permissions.ASSIGN_TASK],
                },
              ]
        }
        onSelectedItemsModalState={setConfirmationModal}
        onOpenActionModal={setActionModal}
        open={actionModal}
      />
      <ConfirmationModal<ITask>
        open={confirmationModal}
        setOpenModal={setConfirmationModal}
        selectedEntities={[selectedTasks, setSelectTasks]}
        title="Tarefas"
        loading={false}
        columns={[
          {
            header: 'Solicitação',
            value: (task) => task.nomeSolicitacao,
          },
          {
            header: 'Execução',
            value: (task) => task.nomeExecucao,
          },
          {
            header: 'Tarefa',
            value: (task) => task.name,
          },
        ]}
        failureList={taskFailures}
      />
      {/* TODO(Cabral): Passar taskInstanceId no lugar de processInstance */}
      <TaskDetails
        open={modalTaskDetail}
        modalState={() => handleModalTaskDetail(null)}
        taskInstance={task}
      />
      {modalAssigneeTask && usersByGroups.length > 0 && assignableTasks && (
        <AssingTaskModalContainer>
          <Modal
            title=""
            loading={loading}
            open={modalAssigneeTask}
            modalState={(opened) => setModalAssigneeTask(opened)}
          >
            <ModalContainer>
              <HeaderContainer>
                <div>
                  <img src={AtribuirUser} alt="" style={{ height: '40px' }} />
                </div>
                <div style={{ marginLeft: '30px' }}>
                  <h1 style={{ margin: '0', fontSize: '22px' }}>
                    Responsável pela tarefa
                  </h1>
                  <p style={{ fontSize: '16px', color: '#777777' }}>
                    Selecione quem irá realizar a tarefa:
                  </p>
                </div>
              </HeaderContainer>

              <FormikProvider value={formik}>
                <Form
                  ref={formRef}
                  onSubmit={formik.handleSubmit}
                  style={{ marginLeft: '40px' }}
                >
                  <SelectInputContainer>
                    <SelectWithAvatar
                      name="userSelected"
                      options={usersByGroups.map((userByGroup) => ({
                        value: userByGroup,
                        label:
                          Number(userByGroup.id) === user.personId
                            ? `${userByGroup.firstName} ${userByGroup.lastName} (Eu)`
                            : `${userByGroup.firstName} ${userByGroup.lastName}`,
                      }))}
                      clearField={modalAssigneeTask}
                    />
                  </SelectInputContainer>
                  <ButtonsContainer>
                    <Button
                      variant="ghost"
                      type="button"
                      styles={{ border: 'none' }}
                      onClick={() => {
                        setModalAssigneeTask(false);
                      }}
                    >
                      CANCELAR
                    </Button>
                    <Button type="submit">
                      {loadingAssignee ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : assignableTasks ? (
                        'CONFIRMAR'
                      ) : (
                        'CONFIRMAR'
                      )}
                    </Button>
                  </ButtonsContainer>
                </Form>
              </FormikProvider>
            </ModalContainer>
          </Modal>
        </AssingTaskModalContainer>
      )}
      {dataListModal && (
        <Modal
          title="Atribuição de tarefas"
          open={dataListModal}
          modalState={(opened) => setDataListModal(opened)}
          size="xs"
        >
          <DataListSync
            values={[
              {
                id: selectedUser?.id,
                label: `${selectedUser?.firstName} ${selectedUser?.lastName}`,
              },
            ]}
            onSubmit={(options) => {
              const newSelectedUser = camundaUsers.find((camundaUser) =>
                options.some((option) => camundaUser.id === option.id),
              );
              setSelectedUser(newSelectedUser);
              setDisableButton(true);
              setFilterParams({});
            }}
            optionsData={camundaUsers.map((camundaUser) => ({
              id: camundaUser.id,
              label: `${camundaUser.firstName} ${camundaUser.lastName}`,
            }))}
            onOpenModal={setDataListModal}
            onFilterOptions={(search) => handleFilterUserOptions(search)}
          />
        </Modal>
      )}
    </Container>
  );
};

export default AvailableTasks;
